// image が読み込み完了したら callback を実行する。
// もしすでに読み込み完了していたら即座に callback を実行する。
// 読み込み失敗も完了とみなす（HTMLImageElement の complete に従う）。
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/complete
export function onComplete(image, callback) {
  if (image.complete) {
    callback();
  } else {
    image.addEventListener("load", callback);
    image.addEventListener("error", callback);
  }
}
